import type { JSX } from 'react';
import { useState } from 'react';
import { Modal, Input, message } from 'antd';
import { useMutation } from '@tanstack/react-query';

import { wikiApi } from '../lib/wikiApi';

/**
 * «Предложить правку» (Q84, PR-style). Читатель вставляет исходный фрагмент
 * статьи и предлагаемую замену + комментарий. УК ревьюит в инбоксе.
 * Если при открытии в браузере было выделение — подставляем как from.
 */
export function SuggestEditModal({
  slug,
  open,
  onClose,
}: {
  slug: string;
  open: boolean;
  onClose: () => void;
}): JSX.Element {
  const [from, setFrom] = useState(() => (open ? window.getSelection?.()?.toString()?.trim() ?? '' : ''));
  const [to, setTo] = useState('');
  const [comment, setComment] = useState('');

  const mut = useMutation({
    mutationFn: () => wikiApi.suggestEdit(slug, { anchor: from.slice(0, 80), from, to, comment }),
    onSuccess: () => {
      message.success('Правка отправлена на ревью УК');
      setFrom(''); setTo(''); setComment('');
      onClose();
    },
    onError: (e: Error) => message.error(e.message),
  });

  return (
    <Modal
      title="Предложить правку"
      open={open}
      onCancel={onClose}
      onOk={() => mut.mutate()}
      okText="Отправить на ревью"
      cancelText="Отмена"
      confirmLoading={mut.isPending}
      okButtonProps={{ disabled: !from.trim() || !to.trim() }}
    >
      <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>
        Вставьте фрагмент статьи, который нужно изменить, и предложите новый
        вариант. УК рассмотрит и применит.
      </p>
      <div style={{ fontSize: 12, fontWeight: 600, margin: '8px 0 4px' }}>Было (фрагмент из статьи):</div>
      <Input.TextArea value={from} onChange={(e) => setFrom(e.target.value)} autoSize={{ minRows: 2, maxRows: 6 }} maxLength={5000} placeholder="Скопируйте сюда текущий текст…" />
      <div style={{ fontSize: 12, fontWeight: 600, margin: '12px 0 4px' }}>Стало (ваш вариант):</div>
      <Input.TextArea value={to} onChange={(e) => setTo(e.target.value)} autoSize={{ minRows: 2, maxRows: 6 }} maxLength={5000} placeholder="Предлагаемая замена…" />
      <div style={{ fontSize: 12, fontWeight: 600, margin: '12px 0 4px' }}>Комментарий (необязательно):</div>
      <Input.TextArea value={comment} onChange={(e) => setComment(e.target.value)} autoSize={{ minRows: 1, maxRows: 4 }} maxLength={2000} placeholder="Почему правка нужна…" />
    </Modal>
  );
}
